export default __webpack_public_path__ + "static/PlayfairDisplay-Italic-0aef4441a9c0a3bd90c3cd1607e45484.woff";